import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'
import { getRawProductsDetails } from './getRawProductsDetails'

async function getDeals(onSuccessEvent, onErrorEvent) {
  const response = await sendRequest()
  const products = await getDealsProducts(response)
  const parsedResponse = parseResponse(response, products)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest() {
  const storeId = await self.servicesVars.getStoreId()
  const url = `${urls.getDeals}${storeId}`
  const response = await Network.sendGetRequest(url)
  return response
}
async function getDealsProducts(response) {
  if (
    !response ||
    response.status.code !== 200 ||
    response?.response?.statusCode !== 200
  )
    return null
  const deals = response.response.data
  const productsIds = deals.map(deal => deal.productId)
  const productsRes = await getRawProductsDetails(productsIds)
  console.log(productsRes)
  if (productsRes.statusCode == 200) return productsRes.data
  return null
}

function parseResponse(response, products) {
  if (
    response &&
    response.status.code === 200 &&
    response?.response?.statusCode == 200
  ) {
    const rawData = response.response.data
    let data = Formatter.parseExternalDeals(products, rawData)

    return {
      success: true,
      data,
    }
  }
  if (
    response &&
    response.status.code === 404 &&
    response.response?.statusCode == 404
  ) {
    const appData = Formatter.parseExternalDeals([])

    return {
      success: true,
      data: appData,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getDeals }
